import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import SyncMonitor from "@/pages/SyncMonitor";
import StockMonitoring from "@/pages/StockMonitoring";
import ProductMaster from "@/pages/ProductMaster";
import ProductDetail from "@/pages/ProductDetail";
import Branches from "@/pages/Branches";
import Backups from "@/pages/Backups";
import ApiDocs from "@/pages/ApiDocs";
import ProductionUnits from "@/pages/ProductionUnits";
import RawMaterials from "@/pages/RawMaterials";
import ProductionSettings from "@/pages/ProductionSettings";
import RMVendors from "@/pages/RMVendors";
import Workers from "@/pages/Workers";
import RMPurchases from "@/pages/RMPurchases";
import RMStocks from "@/pages/RMStocks";
import WorkerLedger from "@/pages/WorkerLedger";
import WorkerLedgerDetail from "@/pages/WorkerLedgerDetail";
import GRNPrint from "@/pages/GRNPrint";
import POPrint from "@/pages/POPrint";
import VendorLedger from "@/pages/VendorLedger";
import RMPurchaseOrders from "@/pages/RMPurchaseOrders";
import Warehouses from "@/pages/Warehouses";
import TaxOtherSettings from "@/pages/TaxOtherSettings";
import L1IssueSlipPrint from "@/pages/L1IssueSlipPrint";
import Fabrication from "@/pages/Fabrication";
import Plating from "@/pages/Plating";
import QualityControl from "@/pages/QualityControl";
import ProductionMonitor from "@/pages/ProductionMonitor";
import { WarehouseStockPage } from "@/pages/StockViews";
import BusinessSettings from "@/pages/BusinessSettings";
import SalesBranches from "@/pages/SalesBranches";
import Customers from "@/pages/Customers";
import ProductPrices from "@/pages/ProductPrices";
import SalesInvoices from "@/pages/SalesInvoices";
import SalesInvoiceEditor from "@/pages/SalesInvoiceEditor";
import SalesInvoicePrint from "@/pages/SalesInvoicePrint";
import Receipts from "@/pages/Receipts";
import LedgerPage from "@/pages/LedgerPage";
import LedgerPrint from "@/pages/LedgerPrint";
import LedgerIndex from "@/pages/LedgerIndex";
import StockTransfers from "@/pages/StockTransfers";
import StockTransferEditor from "@/pages/StockTransferEditor";
import DeliveryChallanPrint from "@/pages/DeliveryChallanPrint";
import BranchStock from "@/pages/BranchStock";
import StockMovements from "@/pages/StockMovements";
import StickerPrint from "@/pages/StickerPrint";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import POSLogin from "@/pages/pos/POSLogin";
import POSShell from "@/pages/pos/POSShell";
import POSScreen from "@/pages/pos/POSScreen";
import POSCashRegister from "@/pages/pos/POSCashRegister";
import POSTerminals from "@/pages/pos/POSTerminals";
import POSStockRequests from "@/pages/pos/POSStockRequests";
import POSStock from "@/pages/pos/POSStock";
import POSSalesReport from "@/pages/pos/POSSalesReport";
import POSBillPrint from "@/pages/pos/POSBillPrint";
import StockRequests from "@/pages/StockRequests";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/pos/login" element={<POSLogin />} />
          <Route path="/pos/bills/:id/print" element={<POSBillPrint />} />
          <Route path="/pos" element={<POSShell />}>
            <Route index element={<POSScreen />} />
            <Route path="register" element={<POSCashRegister />} />
            <Route path="terminals" element={<POSTerminals />} />
            <Route path="requests" element={<POSStockRequests />} />
            <Route path="stock" element={<POSStock />} />
            <Route path="report" element={<POSSalesReport />} />
          </Route>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/sync" element={<SyncMonitor />} />
            <Route path="/stock" element={<StockMonitoring />} />
            <Route path="/products" element={<ProductMaster />} />
            <Route path="/branches" element={<Branches />} />
            <Route path="/backups" element={<Backups />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/wings-api-spec" element={<ApiDocs />} />
            <Route path="/production/units" element={<ProductionUnits />} />
            <Route path="/production/raw-materials" element={<RawMaterials />} />
            <Route path="/production/settings" element={<ProductionSettings />} />
            <Route path="/production/rm-vendors" element={<RMVendors />} />
            <Route path="/production/workers" element={<Workers />} />
            <Route path="/production/rm-purchases" element={<RMPurchases />} />
            <Route path="/production/rm-stocks" element={<RMStocks />} />
            <Route path="/production/worker-ledger" element={<WorkerLedger />} />
            <Route path="/production/worker-ledger/:workerId" element={<WorkerLedgerDetail />} />
            <Route path="/production/vendor-ledger" element={<VendorLedger />} />
            <Route path="/production/rm-purchase-orders" element={<RMPurchaseOrders />} />
            <Route path="/production/warehouses" element={<Warehouses />} />
            <Route path="/production/taxes" element={<TaxOtherSettings />} />
            <Route path="/production/fabrications" element={<Fabrication />} />
            <Route path="/production/platings" element={<Plating />} />
            <Route path="/production/quality-control" element={<QualityControl />} />
            <Route path="/production/monitor" element={<ProductionMonitor />} />
            {/* Legacy alias — Finished Stocks / QC / QC Failed / Pre-QC all lead to the new Quality Control page */}
            <Route path="/production/finished-stocks" element={<QualityControl />} />
            <Route path="/production/qc" element={<QualityControl />} />
            <Route path="/production/qc-failed" element={<QualityControl />} />
            <Route path="/production/preqc-stocks" element={<QualityControl />} />
            <Route path="/production/warehouse-stocks" element={<WarehouseStockPage />} />
            <Route path="/sales/business-settings" element={<BusinessSettings />} />
            <Route path="/sales/branches" element={<SalesBranches />} />
            <Route path="/sales/customers" element={<Customers />} />
            <Route path="/sales/product-prices" element={<ProductPrices />} />
            <Route path="/sales/invoices" element={<SalesInvoices />} />
            <Route path="/sales/invoices/new" element={<SalesInvoiceEditor />} />
            <Route path="/sales/invoices/:id/edit" element={<SalesInvoiceEditor />} />
            <Route path="/sales/receipts" element={<Receipts />} />
            <Route path="/sales/customer-ledger" element={<LedgerIndex payerType="customer" />} />
            <Route path="/sales/franchise-ledger" element={<LedgerIndex payerType="franchise" />} />
            <Route path="/sales/customers/:id/ledger" element={<LedgerPage payerType="customer" />} />
            <Route path="/sales/franchises/:id/ledger" element={<LedgerPage payerType="franchise" />} />
            <Route path="/sales/stock-transfers" element={<StockTransfers />} />
            <Route path="/sales/stock-transfers/new" element={<StockTransferEditor />} />
            <Route path="/sales/stock-transfers/:id/edit" element={<StockTransferEditor />} />
            <Route path="/sales/stock-movements" element={<StockMovements />} />
            <Route path="/sales/branch-stock" element={<BranchStock />} />
            <Route path="/sales/stock-requests" element={<StockRequests />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/admin/users" element={<Users />} />
          </Route>
          <Route path="/production/rm-purchases/:id/print" element={<GRNPrint />} />
          <Route path="/production/purchase-orders/:id/print" element={<POPrint />} />
          <Route path="/sales/invoices/:id/print" element={<SalesInvoicePrint />} />
          <Route path="/sales/customers/:id/ledger/print" element={<LedgerPrint payerType="customer" />} />
          <Route path="/sales/franchises/:id/ledger/print" element={<LedgerPrint payerType="franchise" />} />
          <Route path="/sales/stock-transfers/:id/challan" element={<DeliveryChallanPrint />} />
          <Route path="/production/fabrications/:id/issue-slip" element={<L1IssueSlipPrint />} />
          <Route path="/production/sticker-print" element={<StickerPrint />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
